const LK_EyeOpen =({color,width,height})=>{
    return(
      <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" fill={color}  width={width} height={height} viewBox="0 0 116.99 116.99">
        {/* <defs>
            <style>
            .cls-1 {
                fill: #005c8e;
                stroke-width: 0px;
            }
            </style>
        </defs> */}
        <path class="cls-1" d="M58.5,25.46c-24.81,0-46.54,13.24-58.5,33.04,11.96,19.79,33.69,33.02,58.5,33.02s46.53-13.23,58.49-33.02c-11.96-19.79-33.67-33.04-58.49-33.04ZM58.5,29.63c18.25,0,35.09,7.52,47.08,20.57-14.2-9.69-31.03-14.92-48.42-14.92-14.55,0-28.82,3.72-41.44,10.64,11.57-10.41,26.63-16.3,42.78-16.3ZM80.85,51.27c0,12.13-9.88,21.99-22.01,21.99s-21.99-9.86-21.99-21.99c0-3.33.75-6.59,2.18-9.56,6-1.43,12.2-2.15,18.46-2.15,7.36,0,14.59.98,21.53,2.95,1.19,2.73,1.82,5.74,1.82,8.76ZM58.5,87.36c-21.82,0-41.66-10.74-53.57-28.86.12-.17.23-.35.35-.51,8.52-7,18.35-12.16,28.83-15.24-.91,2.66-1.42,5.54-1.42,8.52,0,14.44,11.71,26.16,26.16,26.16s26.17-11.71,26.17-26.16c0-2.54-.36-5-1.06-7.33,9.93,3.44,19.17,8.81,27.21,15.86-12,17.34-31.39,27.56-52.67,27.56Z"/>
    </svg>
    );
};

export default LK_EyeOpen;